import { createRouter, createWebHistory } from "vue-router";
const routes = [
  {
    path: "/",
    meta: {
      title: "",
    },
  },
  {
    path: "/contact/hl/sdk",
    name: "HlSdk",
    props: {
      channel: "hl",
    },
    component: () => import("@/views/contact/sdk.vue"),
    meta: {
      title: "第三方SDK技术说明",
    },
  },
  {
    path: "/contact/iosNewSdk",
    name: "IosNewSdk",
    props: {
      channel: "ios",
    },
    component: () => import("@/views/contact/iosNewSdk.vue"),
    meta: {
      title: "第三方SDK技术说明",
    },
  },
  {
    path: "/contact/privacyPolicy/ios",
    name: "PrivacyPolicyIOS",
    props: {
      channel: "ios",
    },
    component: () => import("@/views/contact/PrivacyPolicyIOS.vue"),
    meta: {
      title: "隐私政策",
    },
  },
  {
    path: "/contact/userProtocol/ios",
    name: "UserProtocolIOS",
    props: {
      channel: "ios",
    },
    component: () => import("@/views/contact/userProtocolIOS.vue"),
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/failDialog",
    name: "SendFail",
    component: () => import("@/views/dialog/sendFail.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/activity/wholeWorldCall",
    name: "WholeWorldCall",
    component: () => import("@/views/activity/wholeWorldCall.vue"),
    meta: {
      title: "全球喊话",
    },
  },
  {
    path: "/invite/recall",
    name: "InviteLink",
    component: () => import("@/views/ios/InviteLink.vue"),
    meta: {
      title: "甜言",
    },
  },
  {
    path: "/spread/callLandingPage",
    name: "CallRecall",
    component: () => import("@/views/spread/callRecall.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/activity/goldUser",
    name: "GoldUser",
    component: () => import("@/views/activity/goldUser.vue"),
    meta: {
      title: "",
      isTransparent: true,
    },
  },
  {
    path: "/activity/rechargeWelfare",
    name: "RechargeWelfare",
    component: () => import("@/views/activity/rechargeWelfare.vue"),
    meta: {
      title: "累充福利",
      isTransparent: true,
    },
  },
  {
    path: "/ranking/newTv",
    name: "NewTv",
    component: () => import("@/views/ranking/newTv.vue"),
    meta: {
      title: "",
      keepAlive: false,
    },
  },
  {
    path: "/activity/loveStoreStunned",
    name: "LoveStoreStunned",
    component: () => import("@/views/activity/loveStoreStunned"),
    meta: {
      title: "恋爱故事征稿",
      keepAlive: false,
    },
  },
  {
    path: "/recharge/merchant",
    name: "Merchant",
    component: () => import("@/views/recharge/merchant"),
    meta: {
      title: "支付",
      keepAlive: false,
    },
  },
  {
    path: "/rules/inviteRules",
    name: "InviteRules",
    component: () => import("@/views/rules/InviteRules"),
    meta: {
      title: "平台声明",
      keepAlive: false,
    },
  },
  {
    path: "/rules/loveRules",
    name: "LoveRules",
    component: () => import("@/views/rules/loveRules"),
    meta: {
      title: "恋爱基金规则",
      keepAlive: false,
    },
  },
  {
    path: "/rules/preCharmLevel",
    name: "PreCharmLevel",
    component: () => import("@/views/rules/preCharmLevel"),
    meta: {
      title: "升级公告",
      keepAlive: false,
    },
  },
  {
    path: "/rules/letter",
    name: "Letter",
    component: () => import("@/views/rules/letter"),
    meta: {
      title: "情书规则",
      keepAlive: false,
      isTransparent: true,
    },
  },
  {
    path: "/decorate",
    name: "Decorate",
    component: () => import("@/views/decorate/index"),
    meta: {
      title: "装扮中心",
      keepAlive: false,
    },
  },
  {
    path: "/contact/iosSdk",
    name: "IosSdk",
    component: () => import("@/views/contact/iosSdk"),
    meta: {
      title: "第三方sdk",
      keepAlive: false,
    },
  },
  {
    path: "/contact/privateProtocol",
    name: "PrivateProtocol",
    component: () => import("@/views/contact/privateProtocol"),
    meta: {
      title: "隐私协议",
      keepAlive: false,
    },
  },
  {
    path: "/contact/userProtocol",
    name: "UserProtocol",
    component: () => import("@/views/contact/userProtocol"),
    meta: {
      title: "服务协议",
      keepAlive: false,
    },
  },
  {
    path: "/rules/coupon",
    name: "CouponRules",
    component: () => import("@/views/rules/couponRules"),
    meta: {
      title: "优惠券使用规则",
      keepAlive: false,
    },
  },
  {
    path: "/rules/draw",
    name: "DrawRules",
    component: () => import("@/views/rules/drawRules"),
    meta: {
      title: "活动规则",
      keepAlive: false,
    },
  },
  {
    path: "/help/charmLevel",
    name: "CharmLevel",
    component: () => import("@/views/help/charmLevel"),
    meta: {
      title: "个人等级",
      keepAlive: false,
    },
  },
  {
    path: "/invite/index",
    name: "InviteIndex",
    component: () => import("@/views/invite/index"),
    meta: {
      title: "邀请奖励",
      keepAlive: false,
    },
  },
  {
    path: "/rules/report",
    name: "ReportNotice",
    component: () => import("@/views/rules/reportNotice"),
    meta: {
      title: "违规行为举报须知",
      keepAlive: false,
    },
  },
  {
    path: "/rules/disinformation",
    name: "Disinformation",
    component: () => import("@/views/rules/disinformation"),
    meta: {
      title: "开展网络谣言和虚假信息整治公共",
      keepAlive: false,
    },
  },
  {
    path: "/recharge/index",
    name: "RechargeIndex",
    component: () => import("@/views/recharge/index"),
    meta: {
      title: "充值页",
      keepAlive: false,
    },
  },
  {
    path: "/recharge/result",
    name: "StatusPage",
    component: () => import("@/views/recharge/statusPage"),
    meta: {
      title: "结果页",
      keepAlive: false,
    },
  },
  {
    path: "/rules/videoCover",
    name: "VideoCover",
    component: () => import("@/views/rules/videoCover"),
    meta: {
      title: "视频封面",
      keepAlive: false,
    },
  },
  {
    path: "/spread/invite",
    name: "invite",
    component: () => import("@/views/spread/invite"),
    meta: {
      title: "邀请页",
      keepAlive: false,
    },
  },
  {
    path: "/spread/recallLandingPage",
    name: "RecallLandingPage",
    component: () => import("@/views/spread/recallLandingPage"),
    meta: {
      title: "",
      keepAlive: false,
    },
  },
  {
    path: "/task/startChallenges",
    name: "StartChallenges",
    component: () => import("@/views/task/newStartChallenges"),
    meta: {
      title: "星级任务",
      keepAlive: false,
    },
  },
  {
    path: "/banner/firstRecharge",
    name: "BannerFirstRecharge",
    component: () => import("@/views/banner/firstRecharge"),
    meta: {
      title: "首充banner",
      keepAlive: false,
    },
  },
  {
    path: "/rules/videoCard",
    name: "VideoCard",
    component: () => import("@/views/rules/videoCard"),
    meta: {
      title: "好消息，视频卡有收益了",
      keepAlive: false,
    },
  },
  {
    path: "/rules/swindle",
    name: "Swindle",
    component: () => import("@/views/rules/swindle"),
    meta: {
      title: "防诈骗公告",
      keepAlive: false,
    },
  },
  {
    path: "/rules/fraudGuide",
    name: "FraudGuide",
    component: () => import("@/views/rules/fraudGuide"),
    meta: {
      title: "平台交友防骗指南",
      keepAlive: false,
    },
  },
  {
    path: "/score/exchange",
    name: "Exchange",
    component: () => import("@/views/score/exchange"),
    meta: {
      title: "积分兑换",
      keepAlive: false,
    },
  },
  {
    path: "/score/detail",
    name: "ScoreDetail",
    component: () => import("@/views/score/detail"),
    meta: {
      title: "积分详情",
    },
  },
  {
    path: "/score/record",
    name: "ScoreRecord",
    component: () => import("@/views/score/record"),
    meta: {
      title: "兑换记录",
    },
  },
  {
    path: "/contact/sdk",
    name: "SDK",
    component: () => import("@/views/contact/sdk"),
    meta: {
      title: "第三方SDK技术说明",
    },
  },
  {
    path: "/rules/punish",
    name: "RulesPunish",
    component: () => import("@/views/rules/punish"),
    meta: {
      title: "违规处罚制度",
    },
  },
  {
    path: "/customer/question",
    name: "Question",
    component: () => import("@/views/customer/question"),
    meta: {
      title: "问题",
      keepAlive: false,
      isBack: false,
    },
  },
  {
    path: "/help/score",
    name: "HelpScore",
    component: () => import("@/views/help/score"),
    meta: {
      title: "积分问题",
    },
  },
  {
    path: "/customer/answer",
    name: "Answer",
    component: () => import("@/views/customer/answer"),
    meta: {
      title: "答案",
      keepAlive: false,
    },
  },
  {
    path: "/rules/vip",
    name: "VipBanner",
    component: () => import("@/views/rules/vipBanner"),
    meta: {
      title: "开通会员送2400金币",
      keepAlive: false,
    },
  },
  {
    path: "/otherRanking",
    name: "OtherRanking",
    component: () => import("@/views/ranking/newTv.vue"),
  },
  {
    path: "/ranking/rules",
    name: "RankingRules",
    component: () => import("@/views/ranking/rules"),
  },
  {
    path: "/television",
    name: "Television",
    props: {
      tabIndex: 1,
    },
    component: () => import("@/views/ranking/newTv.vue"),
  },
  {
    path: "/profit/question",
    name: "HelpQuestion",
    component: () => import("@/views/profit/question"),
    meta: {
      showNavbar: true,
      title: "常见问题",
    },
  },
  {
    path: "/rules/platform",
    name: "Platform",
    component: () => import("@/views/rules/platform"),
    meta: {
      title: "平台规则",
    },
  },
  {
    path: "/rules/intro",
    name: "IntroStandard",
    component: () => import("@/views/rules/introStandard"),
    meta: {
      title: "自我介绍规范",
    },
  },
  {
    path: "/examine/help",
    name: "Help",
    component: () => import("@/views/examine/help"),
    meta: {
      title: "帮助反馈",
    },
  },
  {
    path: "/rules/userInfo",
    name: "RulesUserInfo",
    component: () => import("@/views/rules/userInfo"),
    meta: {
      title: "个人信息采集",
    },
  },
  {
    path: "/profit/profit",
    name: "Profit",
    component: () => import("@/views/profit/profit"),
    meta: {
      title: "收益",
    },
  },
  {
    path: "/rules/network",
    name: "Network",
    component: () => import("@/views/rules/network"),
    meta: {
      title: "绿色网络公约",
    },
  },
  {
    path: "/mobile/logout",
    name: "Logout",
    component: () => import("@/views/mobile/logout"),
    meta: {
      title: "注销",
    },
  },
  {
    path: "/mobile/code",
    name: "VerifyCode",
    component: () => import("@/views/mobile/verifyCode"),
    meta: {
      title: "手机验证码",
    },
  },
  {
    path: "/rules/standard",
    name: "Standard",
    component: () => import("@/views/rules/standard"),
    meta: {
      title: "头像照片视频规范",
    },
  },
  {
    path: "/rules/prohibit",
    name: "Prohibit",
    component: () => import("@/views/rules/prohibit"),
    meta: {
      title: "平台严禁条例",
    },
  },
  {
    path: "/task/list",
    name: "Task",
    component: () => import("@/views/task/list"),
    meta: {
      title: "任务列表",
    },
  },
  {
    path: "/rules/violation",
    name: "ViolationList",
    component: () => import("@/views/rules/violation"),
    meta: {
      title: "近期违规名单公示",
    },
  },
  {
    path: "/active/returnGift",
    name: "ReturnGift",
    component: () => import("@/views/activity/returnGift"),
    meta: {
      title: "回归礼物",
    },
  },
  {
    path: "/customer/newIndex",
    name: "NewIndex",
    component: () => import("@/views/customer/newIndex"),
    meta: {
      title: "帮助反馈",
      keepAlive: false,
    },
  },
  {
    path: "/profit/earning",
    name: "Earning",
    component: () => import("@/views/profit/earning"),
    meta: {
      title: "收益",
    },
  },
  {
    path: "/profit/withdrawContact",
    name: "WithDrawContact",
    component: () => import("@/views/profit/withDrawContact"),
    meta: {
      title: "提现打款协议",
      keepAlive: false,
    },
  },
  {
    path: "/profit/idcard",
    name: "IdCardUpload",
    component: () => import("@/views/profit/idCardUpload"),
    meta: {
      title: "身份证验证",
      keepAlive: false,
    },
  },
  {
    path: "/profit/resultPage",
    name: "ResultPage",
    component: () => import("@/views/profit/resultPage"),
    meta: {
      title: "认证失败",
      keepAlive: false,
    },
  },
  {
    path: "/profit/binding",
    name: "IosAlipay",
    component: () => import("@/views/profit/alipay"),
    meta: {
      title: "支付宝认证",
      keepAlive: false,
    },
  },
  {
    path: "/profit/newAliplay",
    name: "AuthAlipay",
    component: () => import("@/views/profit/authAlipay"),
    meta: {
      title: "支付宝认证",
      keepAlive: false,
    },
  },
  {
    path: "/profit/alipay",
    name: "Alipay",
    component: () => import("@/views/profit/alipay"),
    meta: {
      title: "支付宝认证",
      keepAlive: false,
    },
  },
  {
    path: "/rules/sliverUserRules",
    name: "SliverUserRules",
    component: () => import("@/views/rules/goldUserRules"),
    meta: {
      title: "白银用户说明",
      isTransparent: true,
    },
  },
  {
    path: "/rules/goldUserRules",
    name: "GoldUserRules",
    component: () => import("@/views/rules/goldUserRules"),
    props: {
      isGold: true,
    },
    meta: {
      title: "黄金用户说明",
      isTransparent: true,
    },
  },
  {
    path: "/rules/recharge",
    name: "Recharge",
    component: () => import("@/views/rules/recharge"),
    meta: {
      title: "充值协议",
    },
  },
  {
    path: "/rules/member",
    name: "Member",
    component: () => import("@/views/rules/member"),
    meta: {
      title: "会员增值协议",
    },
  },
  {
    path: "/limitReward",
    name: "LimitReward",
    component: () => import("@/views/activity/limitReward"),
    meta: {
      title: "",
      isTransparent: true,
    },
  },
  {
    path: "/aiChat/editChat",
    name: "AiChat",
    component: () => import("@/views/aiChat/editChat.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/aiChat/chat",
    name: "AiChatChat",
    component: () => import("@/views/aiChat/chat"),
    meta: {
      title: "",
    },
  },
  {
    path: "/wishGift",
    name: "WishGift",
    component: () => import("@/views/activity/wishGift"),
    meta: {
      title: "",
      isTransparent: true,
    },
  },
  {
    path: "/authentication",
    name: "Authentication",
    component: () => import("@/views/authentication"),
    meta: {
      title: "手把手教你实名认证",
      isTransparent: true,
    },
  },
  {
    path: "/fastFriendships",
    name: "FastFriendships",
    component: () => import("@/views/fastFriendships"),
    meta: {
      title: "快速交友",
      isTransparent: true,
    },
  },
  {
    path: "/ios/member",
    name: "MemberVIP",
    component: () => import("@/views/member"),
    meta: {
      title: "会员",
      isTransparent: true,
    },
  },
  {
    path: "/ios/member/dialog",
    name: "MemberVIPDialog",
    component: () => import("@/views/member/member"),
    meta: {
      title: "会员",
      isTransparent: true,
    },
  },
  {
    path: "/profit/notice",
    name: "Notice",
    component: () => import("@/views/profit/components/notice"),
    meta: {
      title: "公告",
      isTransparent: true,
    },
  },
  {
    path: "/profit/tips",
    name: "Tips",
    component: () => import("@/views/profit/tips"),
    meta: {
      title: "积分扣税",
      isTransparent: true,
    },
  },
  {
    path: "/charge/dialog",
    name: "RechargeDialog",
    component: () => import("@/views/charge/dialog"),
    meta: {
      title: "充值提示",
      isTransparent: true,
    },
  },
  {
    path: "/500",
    name: "Error",
    component: () => import("@/components/MyError"),
    meta: {
      title: "500",
    },
  },
  {
    path: "/:pathMatch(.*)",
    name: "Empty",
    component: () => import("@/components/MyError"),
    meta: {
      title: "404",
    },
  },
];
const prefix = process.env.VUE_APP_PREFIX;
const router = createRouter({
  history: createWebHistory(`${prefix}`),
  routes: routes,
});

export default router;
